import React from 'react';
import { 
  Wifi, AlertTriangle, Smartphone, BrainCircuit, CheckCircle, Users, Activity, AlertCircle,  
  HeartPulse, Clock, ShieldCheck, Target, Compass, 
  Download, Loader2, Sparkles, Brain, PieChartIcon, 
  BarChart3, List 
} from 'lucide-react';

import EditableAIBox from '../EditableAIBox';

// --- 1. BİREYSEL RAPOR ARAYÜZÜ ---
export const InternetBagimliligiReportUI = ({ data, meta }) => {
  const totalScore = data.totalScore || 20; 
  const risks = data.risks || []; 

  let diagnostic = { level: "NORMAL KULLANIM", color: "text-emerald-600", bg: "bg-emerald-500", border: "border-emerald-200", lightBg: "bg-emerald-50", desc: "Öğrenci yaşamında internet kullanımına bağlı herhangi bir sorun yaşamayan 'ortalama internet kullanıcısı'dır." };
  if (totalScore >= 80) {
      diagnostic = { level: "İNTERNET BAĞIMLISI", color: "text-red-600", bg: "bg-red-500", border: "border-red-200", lightBg: "bg-red-50", desc: "İşlevsellikte belirgin bozulma var. İnternet, öğrencinin hayatını tamamen ele geçirmiş durumda. Acil müdahale gerektirir." };
  } else if (totalScore >= 50) {
      diagnostic = { level: "RİSKLİ KULLANIM", color: "text-amber-500", bg: "bg-amber-400", border: "border-amber-200", lightBg: "bg-amber-50", desc: "Öğrenci günlük hayatında internetle ilgili birtakım sorunlar yaşıyor. Bağımlılığa dönüşmeden önlem alınmalı." };
  }

  const guessCategory = (text) => {
    const lower = text.toLowerCase();
    if (lower.match(/fazla süre|birkaç dakika|azaltmaya çalışır|uykunuz kaçar|ihmal/)) return "Zaman Yönetimi ve Tolerans";
    if (lower.match(/düşünceleri dağıtmak|sabırsızlan|internetsiz hayat|kırıcı konuşur|hayal eder|çökmüş/)) return "Yoksunluk ve Duygusal Bağ";
    if (lower.match(/arkadaş|yeni ilişkiler|dışarı çıkmak/)) return "Sosyal İzolasyon";
    if (lower.match(/okul|ders notları|savunur|saklamaya çalışır|şikâyet/)) return "İşlevsellik ve Gizleme";
    return "Genel İnternet Alışkanlığı";
  };

  const categories = {
      "Zaman Yönetimi ve Tolerans": 0,
      "Yoksunluk ve Duygusal Bağ": 0,
      "Sosyal İzolasyon": 0,
      "İşlevsellik ve Gizleme": 0
  };

  const allRisksFormatted = [];
  let criticalCount = 0;

  risks.forEach((r, i) => {
    const text = typeof r === 'object' ? r.text : r;
    const cleanText = text.replace(/\s*\(KRİTİK\)/g, "");
    const category = guessCategory(cleanText);
    
    const isCritical = typeof r === 'object' && r.score >= 4;
    if (isCritical) criticalCount++;

    if (categories[category] !== undefined) categories[category]++;
    allRisksFormatted.push({ id: (typeof r === 'object' ? r.id : (i + 1)), text: cleanText, category, isCritical });
  });

  const maxCategoryCount = Math.max(...Object.values(categories), 1);

  let actionPlan = { title: "Önleyici Rehberlik", desc: "Öğrencinin teknoloji kullanımı sağlıklı sınırlardadır. Dijital okuryazarlık ve güvenli internet becerileri desteklenmeye devam edilmelidir." };
  if (totalScore >= 80) actionPlan = { title: "Klinik Müdahale ve Dopamin Detoksu", desc: "Aile ivedilikle okula davet edilmeli. Evdeki cihaz erişimi kademeli olarak sınırlandırılmalı ve gerekirse Çocuk ve Ergen Psikiyatrisine (teknoloji bağımlılığı polikliniğine) yönlendirilmelidir." };
  else if (totalScore >= 50) actionPlan = { title: "Teknoloji Diyeti ve Sınır Koyma", desc: "Öğrenci ile 'İnternet Kullanım Sözleşmesi' yapılmalı. Ekran süresi takip edilmeli ve internetin yerini alabilecek (spor, sanat vb.) alternatif dopamin kaynakları bulunmalıdır." };

  const gaugePercent = Math.max(0, Math.min(100, ((totalScore - 20) / 80) * 100));
  const isHighVolume = allRisksFormatted.length > 14;

  return (
    <div className="space-y-6 print:space-y-4 font-sans flex flex-col print:min-h-[260mm]">
      
      {/* BAŞLIK VE ÖĞRENCİ BİLGİSİ */}
      <div className={`p-4 print:p-3 rounded-xl flex justify-between items-center shadow-sm print:bg-white print:text-black print:shadow-none print:border-b-2 print:border-slate-900 ${totalScore >= 80 ? 'bg-red-900 text-white' : 'bg-slate-900 text-white'}`}>
        <div className="flex items-center gap-4 print:gap-3">
          <div className={`h-12 w-12 print:h-9 print:w-9 rounded-xl flex items-center justify-center shadow-inner ${totalScore >= 80 ? 'bg-red-600' : 'bg-slate-700'}`}>
            <Wifi className="h-6 w-6 print:h-4 print:w-4"/>
          </div>
          <div>
            <h2 className="text-xl print:text-lg font-bold leading-none mb-1">İnternet Bağımlılığı Analizi</h2>
            <span className="text-[10px] print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">
               {meta?.studentClass || "Sınıf Belirtilmemiş"} • ÖĞRENCİ NO: {meta?.studentNo || "-"}
            </span>
          </div>
        </div>
        <div className="bg-white/10 px-4 py-2 print:px-3 print:py-1.5 rounded-lg text-center print:border print:border-slate-300">
          <span className={`text-2xl print:text-xl font-black block leading-none ${diagnostic.color.replace('text-', 'text-opacity-90 text-')}`}>{totalScore}</span>
          <span className="text-[9px] print:text-[9px] block opacity-70 uppercase font-bold mt-0.5">Test Skoru</span>
        </div>
      </div>

      {/* SİMETRİK ÜST BÖLGE: BAROMETRE VE TEŞHİS KARTI */}
      <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-4 print:gap-4">
         
         <div className="bg-white p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm flex flex-col justify-center print:border-slate-300">
           <div className="flex items-center mb-4 print:mb-2.5 border-b border-slate-100 pb-3 print:pb-2">
             <Smartphone className="h-5 w-5 print:h-4 print:w-4 text-slate-600 mr-3 print:mr-2"/>
             <div>
               <span className="text-sm print:text-[11px] font-black text-slate-800 uppercase tracking-widest block leading-none">Risk Barometresi</span>
               <span className="text-[10px] print:text-[8.5px] font-medium text-slate-400 uppercase tracking-wide mt-0.5 block">(Normal 20-49 | Riskli 50-79 | Bağımlı 80+)</span>
             </div>
           </div>
           
           <div className="flex items-center justify-between mb-2 mt-1">
               <span className="text-[10px] print:text-[8px] font-black text-emerald-600">20</span>
               <div className="flex-1 px-3 print:px-2 flex items-center relative">
                   <div className="h-3 print:h-2 flex-1 bg-emerald-400 rounded-l-full opacity-90"></div>
                   <div className="h-3 print:h-2 flex-1 bg-amber-400 opacity-90"></div>
                   <div className="h-3 print:h-2 flex-1 bg-red-400 rounded-r-full opacity-90"></div>
                   <div className="absolute top-1/2 -translate-y-1/2 w-4 h-4 print:w-3.5 print:h-3.5 bg-white border-4 print:border-[3px] border-slate-900 rounded-full shadow-md" style={{ left: `calc(${gaugePercent}% - 8px)` }}></div>
               </div>
               <span className="text-[10px] print:text-[8px] font-black text-red-600">100</span>
           </div>
           
           <div className="mt-3 flex justify-between text-[9px] print:text-[7.5px] font-bold text-slate-400 uppercase px-4 print:px-2">
               <span className="w-1/3 text-left">Sağlıklı</span>
               <span className="w-1/3 text-center">Riskli</span>
               <span className="w-1/3 text-right">Bağımlı</span>
           </div>
         </div>

         <div className={`${diagnostic.lightBg} p-5 print:p-4 rounded-2xl border ${diagnostic.border} print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm relative overflow-hidden`}>
           <div className={`flex items-center mb-3 print:mb-2 border-b ${diagnostic.border} pb-2 print:pb-1.5 opacity-90 print:border-slate-200`}>
             <AlertTriangle className={`h-5 w-5 print:h-4 print:w-4 mr-2 ${diagnostic.color}`}/>
             <span className={`text-xs print:text-[10.5px] font-black uppercase tracking-widest ${diagnostic.color}`}>Klinik Teşhis & Durum</span>
           </div>
           
           <h3 className={`text-lg print:text-[13px] font-black mb-1.5 print:mb-1 mt-1 leading-tight ${diagnostic.color}`}>
             {diagnostic.level}
           </h3>
           <p className="text-[11px] print:text-[10px] text-slate-800 leading-snug font-medium text-justify">
             {diagnostic.desc}
           </p>
         </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-4 print:gap-4">
         
         <div className="bg-white p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm flex flex-col justify-center print:border-slate-300">
           <h4 className="font-bold text-slate-800 mb-4 print:mb-3 text-sm print:text-[11px] uppercase flex items-center border-b pb-2 print:pb-1.5">
             <BrainCircuit className="h-4 w-4 print:h-3.5 print:w-3.5 mr-2 text-indigo-500"/> Bağımlılık Alt Boyutları
           </h4>
           <div className="space-y-3 print:space-y-2 flex-1 flex flex-col justify-center">
             {Object.entries(categories).map(([name, count], idx) => (
               <div key={name}>
                 <div className="flex justify-between items-end mb-1 print:mb-[2px]">
                   <span className="text-[10px] print:text-[8px] font-bold text-slate-600 uppercase tracking-wide">{name}</span>
                   <span className="text-[10px] print:text-[8px] font-black text-slate-800">{count} Madde</span>
                 </div>
                 <div className="h-2 print:h-1.5 w-full bg-slate-100 rounded-full overflow-hidden print:border print:border-slate-300">
                   <div className="h-full rounded-full bg-indigo-500 print:bg-slate-700" style={{ width: `${(count / maxCategoryCount) * 100}%` }}></div>
                 </div>
               </div>
             ))}
           </div>
         </div>

         <div className="bg-sky-50 p-5 print:p-4 rounded-2xl border border-sky-100 shadow-sm flex flex-col justify-center print:bg-white print:border-slate-300">
           <div className="flex items-center mb-1">
             <Clock className="h-5 w-5 print:h-4 print:w-4 text-sky-600 mr-2"/>
             <span className="text-xs print:text-[10px] font-black uppercase tracking-widest text-sky-900">PDR İlk Müdahale Planı</span>
           </div>
           <h4 className="text-sm print:text-[11.5px] font-black text-sky-800 mb-1.5 mt-1">{actionPlan.title}</h4>
           <p className="text-[13px] print:text-[9.5px] font-medium text-sky-900 leading-snug text-justify">
             {actionPlan.desc}
           </p>
         </div>
      </div>

      <div className="bg-slate-50 p-5 print:p-4 rounded-2xl border border-slate-200 print:bg-white print:border-t-2 print:border-slate-900 print:rounded-none print:shadow-none flex-1 mt-2">
        <div className="flex justify-between items-center border-b pb-3 print:pb-2 mb-4 print:mb-3">
            <h3 className="font-bold text-slate-800 text-sm print:text-[11px] flex items-center">
                <List className="h-4 w-4 mr-2 text-slate-500"/> Sıklıkla Yaşanan Riskli Durumlar ({allRisksFormatted.length})
            </h3>
            <span className="text-[9px] font-bold text-slate-400 uppercase bg-white px-2 py-1 rounded border shadow-sm print:shadow-none">Sadece 3 Puan ve Üzeri</span>
        </div>
        
        {allRisksFormatted.length > 0 ? (
          <div className={`grid grid-cols-1 md:grid-cols-2 ${isHighVolume ? 'print:grid-cols-3 print:gap-1.5' : 'print:grid-cols-2 print:gap-2.5'} gap-3`}>
            {allRisksFormatted.map((item, i) => (
              <div key={i} className={`flex items-start p-3 ${isHighVolume ? 'print:p-1.5' : 'print:p-2'} bg-white border border-slate-200 rounded-xl print:rounded-lg shadow-sm transition-colors ${item.isCritical ? 'border-red-200 bg-red-50/30' : 'hover:border-indigo-200'}`}>
                <div className={`min-w-[24px] h-6 ${isHighVolume ? 'print:min-w-[14px] print:h-3.5 print:text-[7px]' : 'print:min-w-[18px] print:h-4.5 print:text-[8px]'} rounded flex items-center justify-center text-[10px] font-black mr-3 ${isHighVolume ? 'print:mr-1.5' : 'print:mr-2'} border ${item.isCritical ? 'bg-red-100 text-red-700 border-red-200' : 'bg-slate-100 text-slate-600 border-slate-200'}`}>
                  {item.id}
                </div>
                <div className="flex-1">
                  <div className="flex justify-between items-center mb-1 print:mb-[1px]">
                    <span className={`block text-[8px] ${isHighVolume ? 'print:text-[6.5px]' : 'print:text-[7.5px]'} font-bold text-slate-400 uppercase tracking-wider`}>{item.category}</span>
                    {item.isCritical && <span className={`text-[8px] ${isHighVolume ? 'print:text-[6px] px-1 py-[1px]' : 'print:text-[7px] px-1.5 py-0.5'} bg-red-100 text-red-700 rounded font-black tracking-widest uppercase shadow-sm`}>ÇOK SIK</span>}
                  </div>
                  <span className={`text-[11px] ${isHighVolume ? 'print:text-[8px] leading-tight' : 'print:text-[9.5px] leading-snug'} text-slate-800 font-medium block`}>{item.text}</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-6 print:py-4">
            <CheckCircle className="h-8 w-8 text-emerald-400 mx-auto mb-2 opacity-50"/>
            <p className="text-xs text-slate-500 font-medium">Öğrencinin risk teşkil eden yüksek puanlı bir davranışı tespit edilmemiştir.</p>
          </div>
        )}
      </div>
    </div>
  );
};

// --- 2. KURUMSAL (TOPLU) HESAPLAMA MOTORU ---
export const aggregateInternetBagimliligi = (subs) => {
  const total = subs.length;
  if (total === 0) return null;

  const guessCategory = (text) => {
    const lower = text.toLowerCase();
    if (lower.match(/fazla süre|birkaç dakika|azaltmaya çalışır|uykunuz kaçar|ihmal/)) return "Zaman Yönetimi ve Tolerans";
    if (lower.match(/düşünceleri dağıtmak|sabırsızlan|internetsiz hayat|kırıcı konuşur|hayal eder|çökmüş/)) return "Yoksunluk ve Duygusal Bağ";
    if (lower.match(/arkadaş|yeni ilişkiler|dışarı çıkmak/)) return "Sosyal İzolasyon";
    if (lower.match(/okul|ders notları|savunur|saklamaya çalışır|şikâyet/)) return "İşlevsellik ve Gizleme";
    return "Genel İnternet Alışkanlığı";
  };

  let addictedCount = 0; 
  let riskyCount = 0;    
  let normalCount = 0;   
  let totalScoreSum = 0;
  let totalRisksCount = 0;

  const categoryMap = {};
  const classMap = {};
  const itemMap = {}; 

  subs.forEach(s => {
    const className = s.studentClass || s.sinif || s.sınıf || s.class || s.grade || s.studentInfo?.sinif || "Tüm Sınıflar";
    if (!classMap[className]) {
      classMap[className] = { name: className, studentCount: 0, highRiskCount: 0 };
    }
    classMap[className].studentCount++;

    const score = s.reportData?.totalScore || 20;
    totalScoreSum += score;

    if (score >= 80) {
        addictedCount++;
        classMap[className].highRiskCount++;
    } else if (score >= 50) {
        riskyCount++;
        classMap[className].highRiskCount += 0.5; 
    } else {
        normalCount++;
    }

    const risks = s.reportData?.risks || [];
    totalRisksCount += risks.length;

    risks.forEach(r => {
      const text = typeof r === 'object' ? r.text : r;
      const cleanText = text.replace(/\s*\(KRİTİK\)/g, "");
      let cat = typeof r === 'object' && r.category ? r.category : "";
      
      if (!cat || cat === "Genel" || cat === "Diğer Nedenler") {
          cat = guessCategory(cleanText);
      }

      if (!categoryMap[cat]) categoryMap[cat] = 0;
      categoryMap[cat]++;

      const id = typeof r === 'object' ? r.id : cleanText;
      if (!itemMap[id]) itemMap[id] = { id, text: cleanText, count: 0, category: cat };
      itemMap[id].count++;
    });
  });

  const avgScore = total > 0 ? Math.round(totalScoreSum / total) : 20;

  const topCategories = Object.entries(categoryMap)
    .map(([name, count]) => ({ name, count, percent: totalRisksCount > 0 ? Math.round((count / totalRisksCount) * 100) : 0 }))
    .sort((a, b) => b.count - a.count);

  const dominantCategory = topCategories.length > 0 ? topCategories[0] : { name: 'Belirsiz', percent: 0 };

  const classStats = Object.values(classMap).map(c => ({
    ...c,
    riskIntensity: c.studentCount > 0 ? Math.round((c.highRiskCount / c.studentCount) * 100) : 0
  })).sort((a, b) => b.riskIntensity - a.riskIntensity);

  const top3Items = Object.values(itemMap)
    .map(i => ({ ...i, percent: Math.round((i.count / total) * 100) }))
    .sort((a, b) => b.count - a.count)
    .slice(0, 3);

  return { total, addictedCount, riskyCount, normalCount, avgScore, topCategories, dominantCategory, classStats, top3Items };
};


// --- 3. KURUMSAL RAPOR ARAYÜZÜ ---
export const InternetKurumsalUI = ({ title, subs, aiResult, onGenerateAI, aiLoading, handlePrint, downloading }) => {
  const data = aggregateInternetBagimliligi(subs);
  if (!data) return <div className="p-8 text-center text-slate-500">Bu gruba ait veri bulunamadı.</div>;

  const isRedAlarm = data.addictedCount > 0;
  const addictedPercent = data.total > 0 ? Math.round((data.addictedCount / data.total) * 100) : 0;
  const riskyPercent = data.total > 0 ? Math.round((data.riskyCount / data.total) * 100) : 0;
  const normalPercent = 100 - addictedPercent - riskyPercent;

  let interventionObj = {};
  let stakeholderObj = {};

  if (data.dominantCategory.name === "Yoksunluk ve Duygusal Bağ") {
      interventionObj = {
          title: "Duygusal İkame ve Dopamin Detoksu",
          icon: BrainCircuit, color: "text-purple-700", bg: "bg-purple-50 print:bg-white border-purple-200 print:border-slate-300",
          desc: "Öğrenciler interneti bir 'kaçıș ve rahatlama' aracı olarak kullanmakta, onsuz kaldıklarında depresif hissetmektedir.",
          bullets: [
              "Riskli öğrencilerle 'Duygu Regülasyonu' odaklı bireysel psikolojik danışma yapılmalıdır.",
              "Gerçek hayattaki dopamin kaynaklarını (spor, sanat, hobiler) artıracak okul kulüpleri aktifleştirilmelidir.",
              "Ailelere 'Bağımlılıkla Suçlamadan Mücadele' konulu psiko-eğitim verilmelidir."
          ]
      };
      stakeholderObj = {
          title: "Sosyal Bağları Güçlendirme",
          icon: HeartPulse, color: "text-pink-700", bg: "bg-pink-50 print:bg-white border-pink-200 print:border-slate-300",
          desc: "Sanal dünyadaki sahte aidiyet hissi, okulda koşulsuz kabul ve gerçek ilişkilerle değiştirilmelidir.",
          bullets: [
              "Öğretmenler: Öğrencilerin ilgi alanlarına göre onlara sınıf içi ufak sorumluluklar vermelidir.",
              "Sınıf Rehberliği: Akran zorbalığını önleyici ve kaynaştırıcı grup oyunlarına ağırlık verilmelidir.",
              "PDR Odak: Çevrimiçi oyun/sosyal medya gruplarının sınıf içindeki kutuplaşmalara etkisi incelenmelidir."
          ]
      };
  } else if (data.dominantCategory.name === "Zaman Yönetimi ve Tolerans") {
      interventionObj = {
          title: "Sınır Koyma ve Teknoloji Diyeti",
          icon: Clock, color: "text-orange-700", bg: "bg-orange-50 print:bg-white border-orange-200 print:border-slate-300",
          desc: "Temel sorun irade zayıflığıdır. Öğrenciler ekranda geçirdikleri sürenin kontrolünü tamamen kaybetmektedir.",
          bullets: [
              "Kurum genelinde 'Dijital Okuryazarlık ve Ekran Süresi Yönetimi' seminerleri verilmelidir.",
              "Öğrencilere 'Pomodoro' ve benzeri zamanı bloklayarak kullanma teknikleri öğretilmelidir.",
              "Evde 'Teknolojisiz Alanlar' (yemek masası, yatak odası) oluşturulması için velilere broşür gönderilmelidir."
          ]
      };
      stakeholderObj = {
          title: "Yapılandırılmış Çevre Stratejisi",
          icon: ShieldCheck, color: "text-blue-700", bg: "bg-blue-50 print:bg-white border-blue-200 print:border-slate-300",
          desc: "Öğrencilerin kendi kendilerini durduramadığı durumlarda dışsal kurallar ve net sınırlar devreye girmelidir.",
          bullets: [
              "İdare: Okul içinde telefon kullanımıyla ilgili kuralların tavizsiz ve eşit uygulanmasını sağlamalıdır.",
              "Öğretmenler: Ödevleri internette kaybolmayı gerektirmeyecek şekilde (basılı materyal ağırlıklı) revize etmelidir.",
              "Veli İletişimi: Ebeveyn kontrol uygulamaları (Family Link vb.) hakkında veliler eğitilmelidir."
          ]
      };
  } else if (data.dominantCategory.name === "Sosyal İzolasyon") {
      interventionObj = {
          title: "Sosyalleşme ve Gerçek Hayata Dönüş",
          icon: Users, color: "text-blue-700", bg: "bg-blue-50 print:bg-white border-blue-200 print:border-slate-300",
          desc: "Öğrenciler sanal dünyadaki ilişkileri, gerçek hayattaki aile ve arkadaş bağlarına tercih etmeye başlamıştır.",
          bullets: [
              "Yalnızlaşan öğrenciler için sınıf içi sosyometri yapılarak risk haritaları çıkarılmalıdır.",
              "Okulda takım oyunlarına dayalı şubeler arası turnuvalar (spor, münazara) organize edilmelidir.",
              "Öğrencinin evden çıkmasını teşvik edecek yerel sivil toplum (gönüllülük) projeleri tanıtılmalıdır."
          ]
      };
      stakeholderObj = {
          title: "Etkileşimli Okul İklimi",
          icon: Target, color: "text-indigo-700", bg: "bg-indigo-50 print:bg-white border-indigo-200 print:border-slate-300",
          desc: "Teneffüslerin ve okul bahçesinin sadece telefonla oynanan ölü zamanlar olması engellenmelidir.",
          bullets: [
              "İdare: Okul bahçesinde veya koridorlarda öğrencilerin sosyalleşebileceği alanlar/oyunlar kurgulamalıdır.",
              "Veli İletişimi: Hafta sonları çocukla birlikte yapılabilecek 'ekransız' aile etkinlikleri önerilmelidir.",
              "Sınıf Rehberliği: Yüz yüze iletişim becerilerini geliştiren 'drama ve rol oynama' etkinlikleri yapılmalıdır."
          ]
      };
  } else {
      interventionObj = {
          title: "Akademik Koruma ve Yüzleşme",
          icon: AlertTriangle, color: "text-rose-700", bg: "bg-rose-50 print:bg-white border-rose-200 print:border-slate-300",
          desc: "İnternet kullanımı öğrencinin okul başarısını düşürmekte ve yalan söyleme/gizleme gibi davranışlara itmektedir.",
          bullets: [
              "Not düşüşü yaşayan öğrenciler PDR servisine çağrılarak ekran süreleriyle yüzleştirilmelidir.",
              "Ailelere çocuklarının gizli internet/oyun harcamalarına karşı uyarıcı nitelikte bilgi verilmelidir.",
              "Çok yüksek riskli gruptaki (80+ puan) öğrenciler ivedilikle klinik desteğe (Çocuk Psikiyatrisi) yönlendirilmelidir."
          ]
      };
      stakeholderObj = {
          title: "Şeffaf İletişim Ağı",
          icon: Compass, color: "text-teal-700", bg: "bg-teal-50 print:bg-white border-teal-200 print:border-slate-300",
          desc: "Sorunun üstünü örtmek yerine okul ve aile arasında veri odaklı, net bir iletişim köprüsü kurulmalıdır.",
          bullets: [
              "Öğretmenler: Derste uyuklayan veya odaklanamayan öğrencileri hızlıca PDR servisine raporlamalıdır.",
              "PDR Odak: Öğrenciyle çatışmadan, teknoloji kullanımına dair 'Zarar Azaltma' sözleşmeleri imzalanmalıdır.",
              "İdare: Siber zorbalık veya zararlı sitelere erişim konularında bilişim suçları seminerleri organize etmelidir."
          ]
      };
  }

  return (
    <>
      <div className="flex justify-end mb-4 no-print px-2">
         <button onClick={() => handlePrint('internet-kurumsal-area')} disabled={downloading} className="bg-blue-600 text-white px-5 py-2.5 rounded-xl font-bold flex items-center text-sm shadow-md hover:bg-blue-700 transition">
            {downloading ? <Loader2 className="animate-spin h-5 w-5 mr-2"/> : <Download className="h-5 w-5 mr-2"/>} Raporu Yazdır / PDF
         </button>
      </div>

      <div id="internet-kurumsal-area" className="font-sans flex flex-col bg-white print:bg-white">

        {/* ========================================================= */}
        {/* SAYFA 1: DERGİ KAPAĞI - DİJİTAL SAĞLIK VİTRİNİ             */}
        {/* ========================================================= */}
        <div className="flex flex-col gap-5 print:gap-3 mb-6 print:mb-0">
          
          <div className={`p-5 print:p-3 rounded-2xl flex justify-between items-center shadow-sm print:shadow-none print:border-b-2 print:border-slate-900 ${isRedAlarm ? 'bg-red-900 text-white' : 'bg-slate-900 text-white'} shrink-0 avoid-break`}>
            <div className="flex items-center gap-5 print:gap-3">
              <div className={`h-14 w-14 print:h-10 print:w-10 rounded-xl flex items-center justify-center shadow-inner ${isRedAlarm ? 'bg-red-600' : 'bg-slate-700'}`}>
                <Wifi className="h-7 w-7 print:h-5 print:w-5"/>
              </div>
              <div>
                <h2 className="text-2xl print:text-lg font-black leading-none mb-1">{title}</h2>
                <span className="text-xs print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">
                   DİJİTAL SAĞLIK VE BAĞIMLILIK RİSK HARİTASI
                </span>
              </div>
            </div>
            <div className="bg-white/10 px-5 py-2.5 print:px-3 print:py-1.5 rounded-xl text-center print:border print:border-slate-300">
              <span className={`text-3xl print:text-xl font-black block leading-none ${isRedAlarm ? 'text-red-300' : 'text-slate-800'}`}>{data.total}</span>
              <span className="text-[10px] print:text-[8px] block opacity-70 uppercase font-bold mt-1">Katılımcı</span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 print:grid-cols-3 gap-5 print:gap-3 shrink-0 avoid-break">
            <div className={`p-5 print:p-3 rounded-2xl border shadow-sm flex flex-col justify-center print:bg-white print:border-slate-300 ${isRedAlarm ? 'border-red-200' : 'border-slate-200'}`}>
              <div className="flex items-center mb-1.5">
                 <AlertTriangle className={`h-6 w-6 print:h-4 print:w-4 mr-2 ${isRedAlarm ? 'text-red-500' : 'text-emerald-500'}`}/>
                 <span className={`text-sm print:text-[10px] font-black uppercase tracking-widest ${isRedAlarm ? 'text-red-600' : 'text-emerald-600'}`}>Klinik Bağımlı Grubu</span>
              </div>
              <p className={`text-2xl print:text-lg font-black mt-1 ${isRedAlarm ? 'text-red-700' : 'text-emerald-700'}`}>
                 {data.addictedCount} <span className="text-xs print:text-[9px] font-medium opacity-70 text-slate-600 uppercase">Öğrenci (%{addictedPercent})</span>
              </p>
            </div>
            <div className="bg-amber-50 p-5 print:p-3 rounded-2xl border border-amber-100 print:bg-white print:border-slate-300 shadow-sm flex flex-col justify-center">
              <div className="flex items-center mb-1.5">
                 <Activity className="h-6 w-6 print:h-4 print:w-4 mr-2 text-amber-600"/>
                 <span className="text-sm print:text-[10px] font-black text-amber-600 uppercase tracking-widest">Riskli Kullanım Sınırı</span>
              </div>
              <p className="text-2xl print:text-lg font-black text-amber-900 mt-1">
                 {data.riskyCount} <span className="text-xs print:text-[9px] font-medium opacity-70 text-slate-600 uppercase">Öğrenci (%{riskyPercent})</span>
              </p>
            </div>
            <div className="bg-indigo-50 p-5 print:p-3 rounded-2xl border border-indigo-100 print:bg-white print:border-slate-300 shadow-sm flex flex-col justify-center">
              <div className="flex items-center mb-1.5">
                 <Target className="h-6 w-6 print:h-4 print:w-4 mr-2 text-indigo-600"/>
                 <span className="text-sm print:text-[10px] font-black text-indigo-600 uppercase tracking-widest">Baskın Problem Alanı</span>
              </div>
              <p className="text-base print:text-[12px] font-black text-indigo-900 mt-1 leading-tight truncate">
                {data.dominantCategory.name}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-5 print:gap-3 shrink-0 avoid-break mt-1 print:mt-0">
            
            <div className="col-span-1 bg-blue-50 p-5 print:p-3.5 rounded-2xl border border-blue-100 print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm print:shadow-none print:min-h-[90px]">
               <h3 className="font-bold text-blue-900 mb-3 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-blue-200 print:border-slate-200 pb-1.5">
                 <Users className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-blue-600"/> Dijital Kopuş Radarı
               </h3>
               <div className="space-y-2 print:space-y-1 mt-1">
                  <div>
                    <span className="text-[10px] print:text-[8px] font-bold text-blue-500 uppercase tracking-widest block mb-0.5">1. Öncelikli Kriz Grubu</span>
                    <p className="text-sm print:text-[10px] font-black text-slate-800 leading-tight truncate">
                      {data.classStats[0] ? data.classStats[0].name : 'Belirsiz'}
                      {data.classStats[0] && <span className="text-[10px] print:text-[8px] font-bold text-red-600 ml-1">(%{data.classStats[0].riskIntensity} Risk)</span>}
                    </p>
                  </div>
                  <div>
                    <span className="text-[10px] print:text-[8px] font-bold text-slate-500 uppercase tracking-widest block mb-0.5">2. Öncelikli Kriz Grubu</span>
                    <p className="text-xs print:text-[9px] font-black text-slate-700 leading-tight truncate">
                      {data.classStats[1] ? data.classStats[1].name : 'Diğer Gruplar Normal'}
                      {data.classStats[1] && <span className="text-[10px] print:text-[8px] font-bold text-red-500 ml-1">(%{data.classStats[1].riskIntensity} Risk)</span>}
                    </p>
                  </div>
               </div>
            </div>

            <div className="col-span-1 bg-purple-50 p-5 print:p-3.5 rounded-2xl border border-purple-100 print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm print:shadow-none print:min-h-[90px]">
               <h3 className="font-bold text-purple-900 mb-3 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-purple-200 print:border-slate-200 pb-1.5">
                 <Smartphone className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-purple-600"/> Kurumsal Dağılım Barometresi
               </h3>
               
               <div className="flex items-center justify-between mb-1 mt-1 px-1">
                   <span className="text-[9px] print:text-[7.5px] font-bold text-emerald-600 text-center">NORMAL<br/>%{normalPercent}</span>
                   <span className="text-[9px] print:text-[7.5px] font-bold text-amber-600 text-center">RİSKLİ<br/>%{riskyPercent}</span>
                   <span className="text-[9px] print:text-[7.5px] font-bold text-rose-600 text-center">BAĞIMLI<br/>%{addictedPercent}</span>
               </div>
               <div className="h-3 print:h-2 w-full bg-slate-100 rounded-full flex overflow-hidden print:border print:border-slate-300">
                   <div className="h-full bg-emerald-500 print:bg-slate-400" style={{ width: `${normalPercent}%` }}></div>
                   <div className="h-full bg-amber-400 print:bg-slate-600" style={{ width: `${riskyPercent}%` }}></div>
                   <div className="h-full bg-rose-600 print:bg-slate-800" style={{ width: `${addictedPercent}%` }}></div>
               </div>
               
               <p className="text-[10px] print:text-[8px] text-slate-700 leading-snug font-medium mt-2 text-justify line-clamp-2">
                 Okulun genel bağımlılık ortalaması <strong>{data.avgScore}/100</strong> puandır. {data.avgScore > 50 ? 'Teknoloji diyeti gereklidir.' : 'Genel olarak sağlıklı sınırlar içindedir.'}
               </p>
            </div>

            <div className="col-span-2 bg-rose-50 p-4 print:p-3.5 rounded-2xl border border-rose-100 print:bg-white print:border-slate-300 shadow-sm print:shadow-none flex flex-col justify-center">
               <div className="flex justify-between items-center border-b border-rose-200 print:border-slate-200 pb-2 mb-2.5">
                 <h3 className="font-bold text-rose-900 flex items-center text-xs print:text-[10px] uppercase tracking-widest">
                   <AlertCircle className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-rose-600"/> Nokta Atışı: En Sık Görülen 3 Alarm
                 </h3>
                 <span className="text-[10px] print:text-[8px] text-rose-700 print:text-slate-500 italic">Öğrenci Katılım Oranı</span>
               </div>
               
               <div className="space-y-2 print:space-y-1.5 mt-1">
                 {data.top3Items.length > 0 ? data.top3Items.map((item, idx) => (
                   <div key={idx} className="flex justify-between items-start bg-white print:bg-rose-50/30 p-2 print:p-1.5 rounded-lg border border-rose-100 print:border-rose-200 shadow-sm print:shadow-none">
                     <p className="text-[11px] print:text-[9px] font-bold text-slate-800 leading-snug line-clamp-1 pr-2 flex items-center">
                        <span className="text-rose-500 mr-1.5 font-black">{(idx + 1)}.</span> {item.text}
                     </p>
                     <span className="text-xs print:text-[9.5px] font-black text-rose-600 shrink-0">%{item.percent}</span>
                   </div>
                 )) : (
                   <p className="text-xs text-slate-500 italic">Yeterli veri yok.</p>
                 )}
               </div>
            </div>

            <div className="col-span-2 bg-slate-50 p-5 print:p-3.5 rounded-2xl border border-slate-200 print:bg-white print:border-slate-300 shadow-sm print:shadow-none">
               <div className="flex justify-between items-center border-b border-slate-200 print:border-slate-200 pb-2 mb-2">
                 <h3 className="font-bold text-slate-800 flex items-center text-xs print:text-[10px] uppercase tracking-widest">
                   <BarChart3 className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-slate-600"/> Dijital Bağımlılık Boyut Dağılımı
                 </h3>
                 <span className="text-[10px] print:text-[8px] text-slate-500 italic">Genel Risk Yüzdesi</span>
               </div>
               
               <div className="space-y-3 print:space-y-2">
                  {data.topCategories.slice(0, 4).map((dim, idx) => (
                    <div key={idx}>
                      <div className="flex justify-between items-end mb-1 print:mb-0.5">
                        <span className="text-xs print:text-[9px] font-bold text-slate-700">{dim.name}</span>
                        <span className="text-xs print:text-[9px] font-black text-slate-900">%{dim.percent}</span>
                      </div>
                      <div className="h-2 print:h-1.5 w-full bg-slate-200 print:bg-slate-100 rounded-full overflow-hidden print:border print:border-slate-200">
                        <div className="h-full rounded-full bg-indigo-500 print:bg-slate-500" style={{ width: `${dim.percent}%` }}></div>
                      </div>
                    </div>
                  ))}
               </div>
            </div>

          </div>

          <div className="grid grid-cols-2 gap-5 print:gap-3 shrink-0 avoid-break mt-1 print:mt-0">
             
             <div className={`col-span-1 p-5 print:p-4 rounded-2xl border flex flex-col shadow-sm print:shadow-none print:min-h-[140px] ${interventionObj.bg}`}>
                <h3 className="font-bold text-slate-800 mb-2 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-slate-200 print:border-slate-200 pb-2">
                  <interventionObj.icon className={`h-5 w-5 print:h-4 print:w-4 mr-2 ${interventionObj.color}`}/>
                  Kurumsal Müdahale Odağı
                </h3>
                <div className="flex-1 flex flex-col justify-start mt-1">
                  <p className={`text-sm print:text-[11px] font-black leading-tight mb-1.5 ${interventionObj.color}`}>
                      {interventionObj.title}
                  </p>
                  <p className="text-[11px] print:text-[9px] text-slate-600 leading-snug mb-2.5">
                      {interventionObj.desc}
                  </p>
                  <ul className="space-y-1.5 print:space-y-1.5 mt-auto">
                    {interventionObj.bullets.map((b, i) => (
                      <li key={i} className="flex items-start text-[11px] print:text-[8.5px] text-slate-800 font-medium leading-snug">
                        <span className={`mr-1.5 font-black ${interventionObj.color}`}>•</span> {b}
                      </li>
                    ))}
                  </ul>
                </div>
             </div>

             <div className={`col-span-1 p-5 print:p-4 rounded-2xl border flex flex-col shadow-sm print:shadow-none print:min-h-[140px] ${stakeholderObj.bg}`}>
                <h3 className="font-bold text-slate-800 mb-2 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-slate-200 print:border-slate-200 pb-2">
                  <stakeholderObj.icon className={`h-5 w-5 print:h-4 print:w-4 mr-2 ${stakeholderObj.color}`}/>
                  Paydaş Eylem Planı
                </h3>
                <div className="flex-1 flex flex-col justify-start mt-1">
                  <p className={`text-sm print:text-[11px] font-black leading-tight mb-1.5 ${stakeholderObj.color}`}>
                      {stakeholderObj.title}
                  </p>
                  <p className="text-[11px] print:text-[9px] text-slate-600 leading-snug mb-2.5">
                      {stakeholderObj.desc}
                  </p>
                  <ul className="space-y-1.5 print:space-y-1.5 mt-auto">
                    {stakeholderObj.bullets.map((b, i) => (
                      <li key={i} className="flex items-start text-[11px] print:text-[8.5px] text-slate-800 font-medium leading-snug">
                        <span className={`mr-1.5 font-black ${stakeholderObj.color}`}>•</span> {b}
                      </li>
                    ))}
                  </ul>
                </div>
             </div>

          </div>

        </div>
        {/* ==================== 1. SAYFA SONU ==================== */}

        <div className="hidden print:block" style={{ pageBreakBefore: 'always' }}></div>

        {/* ========================================================= */}
        {/* SAYFA 2: YAPAY ZEKA RAPORU VE İMZALAR                    */}
        {/* ========================================================= */}
        <div className="flex flex-col mt-4 print:mt-0">
          
          <div className="bg-purple-50 p-6 print:p-0 rounded-3xl print:rounded-none border border-purple-100 print:border-none shadow-sm print:shadow-none flex flex-col pt-2 print:pt-4">
            <div className="flex justify-between items-center mb-4 print:mb-3 border-b border-purple-200 print:border-slate-300 pb-3 print:pb-3 shrink-0">
              <h3 className="font-bold text-purple-900 flex items-center text-base print:hidden uppercase tracking-widest">
                <Sparkles className="h-5 w-5 mr-2 text-purple-600"/> Yapay Zeka Kurumsal Strateji Raporu
              </h3>
              <h3 className="hidden print:flex items-center font-bold text-slate-900 text-sm uppercase tracking-widest w-full">
                <Brain className="h-5 w-5 mr-2"/> Kurumsal Dijital Sağlık ve Bağımlılık Planı
              </h3>
              <button onClick={() => onGenerateAI(title, data.topCategories)} disabled={aiLoading} className="px-5 py-2.5 bg-purple-600 text-white rounded-xl font-bold text-xs hover:bg-purple-700 transition shadow-sm print:hidden flex items-center">
                {aiLoading ? <Loader2 className="animate-spin h-4 w-4 mr-2"/> : <Brain className="h-4 w-4 mr-2"/>}
                {aiLoading ? "Analiz Ediliyor..." : "Raporu Oluştur"}
              </button>
            </div>
            {aiResult && (
            <div className="bg-white p-6 rounded-xl text-slate-800 border border-purple-100 print:border-0 print:p-0 print:text-black mt-4">
                <EditableAIBox text={aiResult} />
            </div>
        )}
          </div>

          <div className="hidden print:flex justify-between mt-10 pt-4 text-[10px] text-black px-12 shrink-0 border-t border-slate-300">
              <div className="text-center">
                  <p className="font-bold">Okul Psikolojik Danışmanı</p>
                  <p className="mt-16">İmza</p>
              </div>
              <div className="text-center">
                  <p className="font-bold">Okul Müdürü</p>
                  <p className="mt-16">İmza</p>
              </div>
          </div>
          
        </div>
      </div>
    </>
  );
};